<template>
  <div class="container float-container no-margin" :class="{ active: value }">
    <label :for="'select-' + _uid" :class="{ error: error }">{{ label }}</label>
    <select
      :id="'select-' + _uid"
      :disabled="disabled"
      @click="$emit('click')"
      @focus="$emit('onFocus')"
      @blur="onBlur"
      :value="value"
      :name="name"
      @input="$emit('input', $event.target.value)"
      :class="{ error: error }"
      :style="{
        background:
          'url(\'' + imagen + '\') no-repeat right 16px top' + backgroundColor
      }"
    >
      <select-option
        v-for="item in items"
        :label="item.label"
        :value="item.value"
        v-bind:key="item.value"
        :selected="item.value === value"
        :quantumObfuscate="quantumObfuscate"
      />
    </select>

    <span class="error" v-if="error">
      <img src="@/assets/img/1x/error_icon.png" :alt="error" />
      <p>{{ error }}</p>
    </span>
  </div>
</template>

<script>
import SelectOption from "@/components/core/custom/SelectOption";
export default {
  name: "CustomSelect",
  components: { SelectOption },
  props: {
    value: String,
    label: String,
    name: String,
    items: Array,
    disabled: Boolean,
    analyticsTypology: {
      type: String,
      default: null
    },
    quantumObfuscate: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      imagen: require("@/assets/img/1x/arrow-simple-down.svg"),
      backgroundColor: "#f4f4f4"
    };
  },
  methods: {
    onBlur() {
      this.$emit("onBlur");
    }
  }
};
</script>

<style scoped>
div.float-container {
  position: relative;
}

label {
  font-size: 15px;
  color: #666;
  font-family: "BentonSansBBVA-Book", Helvetica, Arial, sans-serif;
  position: absolute;
  -webkit-transform-origin: top left;
  transform-origin: top left;
  -webkit-transform: translate(16px, 19px) scale(1);
  transform: translate(16px, 19px) scale(1);
  transition: all 0.3s ease-in-out;
}
div.float-container.active label {
  -webkit-transform: translate(16px, 8px) scale(0.7);
  transform: translate(16px, 8px) scale(0.7);
  letter-spacing: 1px;
}

/* Estilos para errores */

label.error {
  color: #b92a45;
}

select {
  cursor: pointer;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  padding-left: 16px;
  /* Dar un poco de espacio para "centrar" el texto verticalmente */
  border-top: 17px solid transparent;
  border-bottom: 2px solid #666666;
  height: 48px;
  padding-top: 6px;
}

select.error {
  background-color: #fcdfdf !important;
}

select[disabled] {
  opacity: 0.5;
}

/* Label error */
span.error {
  margin-left: 16px;
  margin-top: 8px;
  display: block;
}

span > img,
span > p {
  display: inline-block;
  vertical-align: top;
}

span > img {
  width: 16px;
}

span > p {
  margin-left: 2px;
  margin-top: 0px;
  margin-bottom: 0px;
  font-family: "BentonSansBBVA-Light", Helvetica, Arial, sans-serif;
  font-size: 12px;
  line-height: 1.33;
  color: #121212;
}
</style>
